export const colors = {
  white: '#FFFFFF',
  mainDark: '#040325',
  aliceBlue: '#DBE9F5',
  textColor: '#4A5F73',
  mainColor: '#FF8A71',
  aliceBlue2: '#E8EFF4',
  ghostWhite: '#F4F7FC',
  ghostWhite2: '#EDF1FA',
  lavenderMist: '#DBE3F5',
  bodyTextColor: '#6C6D84',
  antiFlashWhite: '#E7EBEB',
  imageBackground: '#F6F8FB',
  transparent: 'transparent',
  secondaryTextColor: '#666666',
};

export const theme = {colors};
